import React from "react";
import { VEHICLE_TIPO_CARICO_LABELS } from "@/lib/labels";

/** Sprint 4Z.2 E1 — Badge tipo carico colorato:
 *  - CT / CT Iva → sfondo rosso, testo bianco
 *  - CP / CP Iva → sfondo blu, testo bianco
 *  Tooltip con nome esteso.
 */
const COMPACT = {
  conto_proprio_art36: "CP",
  conto_proprio_iva: "CP Iva",
  conto_terzi: "CT",
  conto_terzi_iva: "CT Iva",
};

const COLOR = {
  conto_proprio_art36: "bg-blue-600 text-white border-blue-700",
  conto_proprio_iva: "bg-blue-600 text-white border-blue-700",
  conto_terzi: "bg-rose-600 text-white border-rose-700",
  conto_terzi_iva: "bg-rose-600 text-white border-rose-700",
};

export default function TipoCaricoBadge({ value, size = "md", className = "" }) {
  if (!value) return <span className="text-slate-300">—</span>;
  const lbl = COMPACT[value] || value;
  const color = COLOR[value] || "bg-slate-200 text-slate-700 border-slate-300";
  const px = size === "sm" ? "px-1.5 py-0.5 text-[10px]" : "px-2 py-0.5 text-[11px]";
  return (
    <span
      className={`inline-flex items-center font-semibold rounded border ${color} ${px} ${className}`}
      title={VEHICLE_TIPO_CARICO_LABELS[value] || value}
      data-testid={`tipo-carico-badge-${value}`}
    >
      {lbl}
    </span>
  );
}
